"use client";
import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import ServiceList from "@/components/service/ServiceList";

// gsap.registerPlugin(SplitText);

const AllServices = ({ data }) => {
  const services = data?.services;

  return (
    <StyledComponent>
      <ServiceList data={services} margin={"0 0 48px"} />
    </StyledComponent>
  );
};

const StyledComponent = styled.section``;

export default AllServices;
